export const MEDIA_QUERIES = {
  BIG_DESKTOP: "(min-width: 1800px)",
  TAB_LAND: "(max-width: 1200px)",
  TAB_PORT: "(max-width: 900px)",
  PHONE: "(max-width: 600px)",
  SMALL_PHONE: "(max-width: 300px)",
};
